import { SocketGameDetails } from './SocketGameDetails';
import { MobxMapAutoNew } from 'src_common/common/mobx-utils/MobxMapAutoNew';
import { SocketGameList } from './SocketGameList';
import { CasinoTableModel } from './CasinoTableModel';
import { ConfigState } from 'src/domains/casino/state/AppCasino/ConfigState';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { Common } from 'src/domains/common/Common';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';

/*
const CasinoSocketConfig = [{
label: "Prod - Star",
host: "dga.pragmaticplaylive.net",
casinoId: "ppcdg00000004198",
}, {
label: "Prod - Mcbookie",
host: "dga.pragmaticplaylive.net",
casinoId: "ppcdg00000004197",
}, {
label: "STG - Mcbookie",
host: "prelive-dga.pragmaticplaylive.net",
casinoId: "ppcdk00000005025",
}];
*/

type ConfigType = {
    host: string;
    casinoId: string;
};

const getConfig = (config: ConfigState): ConfigType | null => {
    return config.commonConfig.socketPragmatic;
};

export class LiveCasinoSocket {
    private readonly listAvaiable: SocketGameList | null = null;
    private readonly data: MobxMapAutoNew<string, SocketGameDetails> | null = null;
    private readonly hasReportedMessageForTable: Set<string> = new Set();

    public constructor(private readonly common: Common) {
        const config = new ConfigState(this.common);
        const socketConfig = getConfig(config);
        const isBrowser = EnvironmentState.get(this.common).isBrowser;
        if (socketConfig !== null) {
            this.listAvaiable = new SocketGameList(socketConfig.host, socketConfig.casinoId, isBrowser);
            this.data = new MobxMapAutoNew(
                (currency: string): SocketGameDetails =>
                    new SocketGameDetails(socketConfig.host, socketConfig.casinoId, currency, isBrowser, config)
            );
        }
    }

    private get socket(): SocketGameDetails | null {
        if (this.data === null) {
            return null;
        }

        const currency = BasicDataModel.get(this.common).currency;
        return this.data.get(currency);
    }

    public getModel(tableId: string): CasinoTableModel | null {
        const list = this.listAvaiable?.list ?? null;

        if (list === null || this.socket === null) {
            return null;
        }

        if (list.includes(tableId) === false) {
            if (this.hasReportedMessageForTable.has(tableId) === false) {
                this.hasReportedMessageForTable.add(tableId);
                console.warn(`DGA Live Casino - not avaible information about ${tableId}`);
            }

            return null;
        }

        return this.socket.getModel(tableId);
    }
}
